import { Card, CardContent } from '../ui/card';
import { fmtCurrency } from '../../lib/localeUtils';

const ITEMS = [
  { key: 'total_cost', label: 'Cost (active)', money: true },
  { key: 'accumulated_depreciation', label: 'Accumulated depreciation', money: true },
  { key: 'net_book_value', label: 'Net book value', money: true },
  { key: 'annual_depreciation', label: 'This year\u2019s charge', money: true },
  { key: 'active_count', label: 'Active assets' },
];

export const AssetSummaryCards = ({ summary }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
    {ITEMS.map((it) => (
      <Card key={it.key}>
        <CardContent className="p-3">
          <p className="text-[10px] uppercase tracking-wide text-muted-foreground font-semibold">{it.label}</p>
          <p className="text-lg font-bold mt-0.5" data-testid={`asset-summary-${it.key}`}>
            {it.money ? fmtCurrency(summary[it.key] || 0) : (summary[it.key] || 0)}
          </p>
        </CardContent>
      </Card>
    ))}
  </div>
);
